import { ChangeDetectorRef, Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';

@Component({
  selector: 'app-customer-telling',
  templateUrl: './customer-telling.component.html',
  styleUrls: ['./customer-telling.component.scss']
})
export class CustomerTellingComponent implements OnChanges {
  @ViewChild('videoPlayer', { static: false }) videoplayer: ElementRef<HTMLVideoElement>;
  isPlay = false;

  @Input() customer: {
    name: "",
    profileImage: "",
    job: "",
    text: "",
    video: ""
  };

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['customer'] && this.videoplayer) {
      this.videoplayer.nativeElement.load();
      this.isPlay = false; 
      this.cdr.markForCheck();
    }
  }

  toggleVideo(): void {
    const video = this.videoplayer.nativeElement;
    if (this.isPlay) {
      video.pause();
    } else {
      video.play();
    }
    this.isPlay = !this.isPlay;
    this.cdr.markForCheck();
  }

  isMobile(): boolean {
    return window.innerWidth <= 991;
  }
}
